import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import {
  numberWithCommas,
  RupeesToPaise,
} from "../../../utility/commaSeperator";
import { dateConvert } from "../../../utility/dateModifier";
import {
  FailedTransaction,
  SuccessTransaction,
} from "../../resources/assetsManager";
import {
  BLACK_COLOR,
  SIDEBAR_COLOR,
  WHITE_COLOR,
} from "../../resources/colorsManager";
import { SUCCESS } from "../../resources/constantsManager";

const TransactionContainer = ({ isCredited, amount, date, trnxId }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: 5,
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          <img
            src={isCredited ? SuccessTransaction : FailedTransaction}
            style={{
              width: 30,
              height: 30,
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              lineHeight: "101%",
              justifyContent: "flex-start",
              marginLeft: 15,
            }}
          >
            <p
              style={{
                fontSize: 15,
                fontWeight: "500",
                padding: 0,
                margin: 0,
                color: BLACK_COLOR,
              }}
              className="roboto"
            >
              {isCredited ? "Credit" : "Debit"}
            </p>
            <p
              style={{
                fontSize: 12,
                padding: 0,
                margin: 0,
                color: BLACK_COLOR,
                fontWeight: "500",
              }}
              className="roboto"
            >
              {date}
            </p>
            <p
              style={{
                fontSize: 12,
                padding: 0,
                margin: 0,
                color: BLACK_COLOR,
                fontWeight: "500",
              }}
              className="roboto"
            >
              {"UTR No: " + trnxId}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{
              color: isCredited ? "#17AA40" : "#EE3C3C",
              fontWeight: "500",
              fontSize: "17px",
            }}
            className="roboto"
          >
            {"₹" + amount}
          </p>
        </div>
      </div>
    </>
  );
};
function RecentTransaction({ width }) {
  const navigate = useNavigate();
  const [data, setData] = useState("");

  const getVanTransactionHistory = (page, size, dateRange, utr, van) => {
    ApiRequestPost.vanTransactionHistory(page, size, dateRange, utr, van)
      .then((res) => {
        if (res.status === SUCCESS) {
          setData(res?.data?.content?.slice(0, 5));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    getVanTransactionHistory(0, 10);
  }, []);

  return (
    <div
      style={{
        width: width > 1000 ? "40%" : "100%",
        backgroundColor: "#F3F3F3",
        padding: width > 1000 ? 20 : 0,
        borderRadius: 30,
      }}
    >
      <div
        style={{
          backgroundColor: WHITE_COLOR,
          height: "100%",
          padding: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 30,
        }}
      >
        <p
          style={{
            fontSize: 19,
            fontWeight: "500",
            color: BLACK_COLOR,
            margin: 0,
          }}
          className="roboto"
        >
          Recent Transaction
        </p>

        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            marginTop: 20,
            width: "100%",
          }}
        >
          {data?.length > 0 &&
            data.map((trans, index) => (
              <>
                <TransactionContainer
                  isCredited={!trans.debit}
                  trnxId={trans.transferUniqueNo}
                  date={dateConvert(trans.createdDate, false)}
                  amount={numberWithCommas(RupeesToPaise(trans.transferAmt))}
                />
              </>
            ))}
          {data?.length === 0 && (
            <>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    color: "black",
                    fontSize: 14,
                  }}
                >
                  No Transaction Found
                </p>
              </div>
            </>
          )}
        </div>

        <p
          style={{
            fontSize: 16,
            color: SIDEBAR_COLOR,
            cursor: "pointer",
            margin: 0,
          }}
          onClick={() => {
            navigate("/transaction");
          }}
        >
          View All
        </p>
      </div>
    </div>
  );
}

export default RecentTransaction;
